import { cn } from "@/lib/utils";

interface WordmarkProps {
  className?: string | null
  inverted?: boolean
}

export function Wordmark({ className = null, inverted = false }: WordmarkProps) {
  return (
    <div className={cn(
      "flex h-14 justify-start items-center",
      className
    )}>
      {inverted ? (
        <>
          <img src="/logo-dark.svg" className="dark:hidden h-full object-cover" />
          <img src="/logo-light.svg" className="hidden dark:block h-full object-cover" />
        </>
      ) : (
        <>
          <img src="/logo-light.svg" className="dark:hidden h-full object-cover" />
          <img src="/logo-dark.svg" className="hidden dark:block h-full object-cover" />
        </>
      )}
    </div>
  )
}
